import { EntityFieldTypeName } from '@skinsoft/types';
import { AliasDataStore, ContainerDataStore, ItemDataStore, LocationDataStore, ThesaurusTermDataStore, ArchiveDataStore, SpecimenDataStore } from '..';

// Cannot type as DataStore (because of circular dependencies between the array down bellow and DataStore).
// Need to create an interface (in the Java meaning of the word) for DataStore
export const DATASTORES_FROM_REFERENCE_ENTITY_TYPE: Partial<Record<EntityFieldTypeName, any>> = {
    Alias: AliasDataStore,
    Archive: ArchiveDataStore,
    ContainerItem: ContainerDataStore,
    ThesaurusTerm: ThesaurusTermDataStore,
    Item: ItemDataStore,
    MuseumItem: ItemDataStore,
    Location: LocationDataStore,
    Specimen: SpecimenDataStore
}